<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_provider") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #ef3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-select-input
            col="6"
            :optionsList="providers"
            :placeholder="$t('PLACEHOLDERS.provider')"
            v-model="data.provider"
            required
          />
          <base-select-input
            col="6"
            :optionsList="selection_priorities"
            :placeholder="$t('PLACEHOLDERS.selection_priority')"
            v-model="data.selection_priority"
            required
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-5"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import UploadsPhotos from "@/components/formInputs/UploadsPhotos.vue";
import ChangableMapComponent from "@/components/general/ChangableMapComponent";

export default {
  components: { UploadsPhotos, ChangableMapComponent },
  data() {
    return {
      isWaitingRequest: false,
      data: {
        work_hours: [
          {
            // id : null,
            day_id: { id: null, name: null },
            start_time: null,
            end_time: null,
            // created_at:null
          },
        ],
        dayMappingToEnglish: {
          الأحد: "Sunday",
          الاثنين: "Monday",
          الثلاثاء: "Tuesday",
          الأربعاء: "Wednesday",
          الخميس: "Thursday",
          الجمعة: "Friday",
          السبت: "Saturday",
        },
        logo: { path: "", file: "" },
        commercial_register_image: { path: "", file: "" },
        commercial_register: "",
        name: "",
        store_name_ar: "",
        store_name_fr: "",
        mobile: "",
        email: "",
        provider: null,
        passwordConfirmation: "",
        description_ar: "",
        description_fr: "",
        preparation_time: "",
        store_category: null,
        latitude: 18.0735,
        longitude: -15.9582,
        area: "",
        selection_priority: null,
        city: "",
        district: "",
        street: "",
        building: "",
        bank_name: "",
        bank_account: "",
        iban: "",
        address: "",
      },
      imgUrls: [],
      store_categories: [],
      providers: [],
      banks: [],
    };
  },
  computed: {
    selection_priorities() {
      return [
        { id: 1, name: 1, value: 1 },
        { id: 2, name: 2, value: 2 },
        { id: 3, name: 3, value: 3 },
        { id: 4, name: 4, value: 4 },
        { id: 5, name: 5, value: 5 },
        { id: 6, name: 6, value: 6 },
        { id: 7, name: 7, value: 7 },
        { id: 8, name: 8, value: 8 },
        { id: 9, name: 9, value: 9 },
        { id: 10, name: 10, value: 10 },
      ];
    },
    filteredDays() {
      const usedDays = new Set(
        this.data.work_hours.map((workHour) => workHour.day_id?.id)
      );
      const usedDaysNames = new Set(
        this.data.work_hours.map((workHour) => workHour.day_id?.name)
      );
      console.log("1111", usedDays);
      console.log("2222", Object.values(this.dayMapping));
      return Object.values(this.dayMapping).filter(
        (day) => !usedDaysNames.has(day.name)
      );
    },
  },
  methods: {
    addWorkDay() {
      this.data.work_hours.push({
        day_id: null,
        start_time: null,
        end_time: null,
      });
    },

    async removeWorkDay(index, item_index) {
      if (this.data.work_hours.length > 0) {
        this.data.work_hours.splice(item_index, 1);
      } else {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.errors.message[0]);
      }
    },
    selectImageStore(selectedImage) {
      this.data.logo = selectedImage;
    },
    selectImageCR(selectedImage) {
      this.data.commercial_register_image = selectedImage;
    },
    onFileSelect(files) {
      this.additionalImages = files;
    },
    onFileRemove(index) {
      this.$delete(this.imgUrls, index);
    },
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    async submitForm() {
      const formData = new FormData();
      if (this.data.selection_priority) {
        formData.append(
          "selection_priority",
          this.data.selection_priority?.value
        );
      }
      if (this.data.provider) {
        formData.append("provider_id", this.data.provider?.id);
      }
      try {
        await this.$axios.post("/selected-providers", formData);
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push("/chosen/all");
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    async getCategories() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `providers?selected=0`,
          params: {
            is_active: 1,
            page: 0,
            limit: 0,
          },
        });
        this.providers = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getBanks() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `banks?page=0&limit=0`,
          params: {
            is_active: 1,
            page: 0,
            limit: 0,
          },
        });
        this.banks = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },
  mounted() {
    this.getCategories();
    // this.getBanks();
  },
};
</script>
